/**
 * KAN-753: после входа в кабинет: "Кто работает с клиентами?". Выбор менеджера
 * необязателен: "Пропустить" (или закрытие окна) больше не спрашивает до
 * следующего входа. KAN-852: выбранный менеджер подставляется в окно
 * "Назначить в работу" у клиента без менеджера.
 */
import { UserRound } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useSessionManager } from '@/hooks/useSessionManager';

export function SessionManagerPrompt() {
  const { showPrompt, managers, select, skip } = useSessionManager();

  return (
    <Dialog
      open={showPrompt}
      onOpenChange={(open) => {
        if (!open) skip();
      }}
    >
      <DialogContent className="max-w-md" data-testid="session-manager-prompt">
        <DialogHeader>
          <DialogTitle>Кто работает с клиентами?</DialogTitle>
          <DialogDescription>
            Менеджер подставится в окно "Назначить в работу" у клиента без менеджера. Сменить
            его можно в шапке кабинета.
          </DialogDescription>
        </DialogHeader>
        <ul className="max-h-72 space-y-1 overflow-y-auto" aria-label="Менеджеры">
          {managers.map((m) => (
            <li key={m.id}>
              <button
                type="button"
                onClick={() => select(m.id)}
                className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
              >
                <UserRound className="h-4 w-4 shrink-0 text-gray-400" aria-hidden="true" />
                {m.full_name}
              </button>
            </li>
          ))}
        </ul>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={skip}>
            Пропустить
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
